export const DEFAULT_PAGE_SIZE = 25;

export const CACHE_BLOCK_SIZE = 25;

export const PAGE_SIZE_SELECTOR = [10, DEFAULT_PAGE_SIZE];